'use client'

import { useEffect } from 'react'
import { runYdocRecoverySnapshots } from '@/lib/ydocRecoverySnapshot'

/**
 * Renders nothing. Kicks off the one-shot upload of local y-indexeddb replicas
 * for bricked-room projects (see lib/ydocRecoverySnapshot.ts). Delayed so it
 * stays out of the app-boot critical path and auth session restore has settled.
 */
export function YdocRecoverySnapshot() {
  useEffect(() => {
    const timer = window.setTimeout(() => void runYdocRecoverySnapshots(), 8000)
    return () => window.clearTimeout(timer)
  }, [])
  return null
}
